var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.875H14.0859L13.0234 3.28125C12.9669 3.19411 12.8893 3.12264 12.7978 3.07348C12.7063 3.02432 12.6039 2.99904 12.5 3H7.5C7.39613 2.99904 7.29371 3.02432 7.20221 3.07348C7.11071 3.12264 7.0331 3.19411 6.97656 3.28125L5.91406 4.875H3.75C3.25335 4.87705 2.77763 5.07526 2.42645 5.42644C2.07526 5.77763 1.87706 6.25335 1.875 6.75V15.5C1.87706 15.9966 2.07526 16.4724 2.42645 16.8235C2.77763 17.1747 3.25335 17.3729 3.75 17.375H16.25C16.7466 17.3729 17.2224 17.1747 17.5736 16.8235C17.9247 16.4724 18.1229 15.9966 18.125 15.5V6.75C18.1229 6.25335 17.9247 5.77763 17.5736 5.42644C17.2224 5.07526 16.7466 4.87705 16.25 4.875ZM12.8125 10.8125C12.8125 11.3688 12.6475 11.9125 12.3385 12.375C12.0295 12.8376 11.5902 13.198 11.0763 13.4109C10.5624 13.6238 9.99688 13.6795 9.45131 13.571C8.90574 13.4624 8.4046 13.1946 8.01126 12.8012C7.61793 12.4079 7.35006 11.9068 7.24154 11.3612C7.13302 10.8156 7.18872 10.2501 7.40159 9.7362C7.61446 9.22228 7.97495 8.78303 8.43746 8.47399C8.89997 8.16495 9.44374 8 10 8C10.7459 8 11.4613 8.29631 11.9887 8.82376C12.5162 9.3512 12.8125 10.0666 12.8125 10.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d69ae2c669f346d24766b0dd08876384.svg";
export { ForwardRef as ReactComponent };